{
  "dss": {
    "button": {
      "back": "戻る",
      "cancel": "キャンセル",
      "close": "閉じる",
      "confirmDelete": "はい、削除します",
      "continue": "続行",
      "logout": "ログアウト",
      "passwordReset": "パスワードリセット",
      "save": "保存",
      "verify": "確認"
    },
    "error": {
      "403": "このページにはアクセスできません。",
      "404": "このページは存在しません。",
      "generic": "エラーが発生しました。 後でもう一度試してください.",
      "invalidConfirmationLink": "確認リンクの有効期限が切れているか、その他の理由で無効になっています。",
      "throttling": "試行回数が多すぎます。この操作はしばらくブロックされます.",
      "title": "エラー",
      "title403": "アクセス拒否",
      "title404": "見つかりません"
    },
    "footer": {
      "imprint": "インプリント",
      "legalEntity": "STIHL CO.,LTD.",
      "privacy": "プライバシーポリシー",
      "terms": "利用規約"
    },
    "label": {
      "CRMAccountNumber": "CRM アカウント番号",
      "contact": "問い合わせる",
      "email": "電子メール",
      "faq": "FAQ",
      "female": "さん。",
      "firstname": "名",
      "help": "ヘルプ",
      "language": "言語",
      "lastname": "姓",
      "male": "ミスター",
      "needHelp": "お問い合わせ",
      "newPassword": "新しくセットするパスワード",
      "newPassword2": "新しくセットするパスワード（確認入力）",
      "oldPassword": "現在のパスワード",
      "organization": "所属組織",
      "password": "パスワード",
      "required": "必須フィールド",
      "salutation": "御利用登録者様へ、",
      "select": "選択してください"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "登録の確認",
        "wait": "アカウントの確認が完了するまでお待ちください。"
      },
      "otp": {
        "btnResend": "認証コードメールの再送",
        "msg": {
          "invalidOTP": "入力されたワンタイムパスワードが無効です。",
          "resendFail": "コードの再送に失敗しました。後で再試行してください。"
        },
        "spamDetail": "STIHL Support (noreply{'@'}stihl-sso.com) からのメールが届いていないか、受信トレイと迷惑メールフォルダを確認してください。",
        "spamTitle": "メールは届いていないのですか？",
        "subtitle": "続行するには、メールアドレスを確認する必要があります。",
        "title": "ユーザーアカウントの確認",
        "txtVerifyMail": "お客様のEメールアドレスにお送りした新しい認証コードを入力してください {email}"
      },
      "personal": {
        "msg": {
          "noChange": "更新するものは何もない。",
          "updateError": "個人情報の更新に失敗しました。",
          "updated": "個人情報を更新しました。",
          "userLoadErr": "ユーザーデータの読み込みにエラーが発生しました。後で再試行してください。"
        },
        "secOrganization": "所属組織",
        "secPersonal": "利用者",
        "secSettings": "設定",
        "title": "利用者情報"
      },
      "postPwSet": {
        "info": "新しいパスワードを使用してください。",
        "link_name": "進む",
        "title": "パスワード変更は完了しました。"
      },
      "resetPW": {
        "title": "パスワードをリセットする"
      },
      "security": {
        "2fa": {
          "availableMethods": "利用可能な2FAの方法：",
          "info": "2要素認証（2FA）は、アカウントに追加の保護層を追加するセキュリティ機能です。ユーザー名とパスワードだけでなく、2つの認証方法を使用する必要があります。",
          "method": {
            "email": "メール",
            "emailDesc": "認証要求を完了するために、一度限りのコードがメールで送信されます。",
            "oath": {
              "add": {
                "button": "認証アプリを登録"
              }
            }
          }
        },
        "authenticator": "認証アプリ",
        "infoFederatedAccount": "このアカウントはお客様の組織のIDプロバイダーによって管理されているため、ここではパスワードを変更できません。パスワードを変更するには、組織のログインページからサインインするか、IT管理者にお問い合わせください。",
        "lastUse": "最後に使用されたのは {0} です。",
        "msg": {
          "invalidPassword": "現在のパスワードが無効です。",
          "passwordAlreadyUsed": "過去5回分のパスワードは再利用できません。",
          "pwUpdateError": "パスワードを変更しようとしてエラーが発生しました。",
          "pwUpdated": "パスワードが変更された。"
        },
        "noDevice": "未設定",
        "oathAdd": {
          "appInfo": "{0}、{1} などの認証アプリは、ログイン時に 2 番目の要素として使用されるワンタイム パスワードを生成します。",
          "badCode": "無効なコードです。もう一度お試しください。",
          "error": "認証デバイスの登録中にエラーが発生しました。",
          "headScan": "1. 認証アプリで QR コードをスキャンする。",
          "headVerify": "2. コードを確認する",
          "infoKey": "セットアップ キー",
          "infoKeyTitle": "2 要素シークレット",
          "infoScanBottom": "スキャンできませんか? {0} を使用して認証アプリを手動で設定できます。",
          "infoVerify": "認証アプリによって生成されたコードを入力してください。",
          "success": "認証デバイスが登録されました。これでサインインに使用できます。",
          "title": "2 要素認証デバイスを登録する"
        },
        "oathDelete": {
          "error": "認証デバイスの削除中にエラーが発生しました。",
          "success": "認証デバイスが削除されました。"
        },
        "passkeys": {
          "about": {
            "info1": "パスキーは暗号化キーのペア（公開キーと秘密キー）で構成され、あなたが管理する認証デバイスに保存されます。認証デバイスは、ユーザーが存在し、かつそのパスキーを使用する権限があることを証明できます。認証デバイスは、PIN、パスコード、生体認証、またはデバイスパスワードを用いて認証を行います。認証デバイスには、iPhoneやAndroidデバイス、Windows Hello、FIDO2ハードウェアセキュリティキー、またはパスワードマネージャーなど、さまざまな形式があります。",
            "info2": "STIHLにパスキーを使用してサインインすると、認証デバイスは公開鍵暗号を使用して、パスキーを送信することなくSTIHLに対してあなたの身元を証明します。パスキーはstihl-sso.comのようなウェブサイトのドメインに関連付けられており、安全な接続が必要です。これにより、ウェブブラウザはフィッシング詐欺の類似サイトへの認証を拒否します。これらの特性により、パスキーはフィッシング攻撃に対して非常に強力で、SMSやTOTP 2FA（フィッシングの可能性がある）よりもはるかに攻撃を受けづらい状態を作り出します。",
            "info3": "クラウド対応のパスキーサービスを使用すると、AppleデバイスやAndroidデバイス、またはパスワードマネージャーのようなデバイス間でパスキーを同期できます。これにより、パスキーは複数の場所から使用可能になり、紛失もしにくくなります。一度、1つのデバイスで同期済みのパスキーを設定すれば、同じサービスを使用するデバイス全体でこのパスキーを利用できます。たとえば、MacBookのTouch IDを使ってiCloudアカウントにパスキーを登録すると、そのパスキーを顔、指紋、PIN、またはデバイスパスワードで他の複数デバイスで使用できます。",
            "title": "パスキーについて"
          },
          "add": {
            "button": "新しいパスキーを追加する",
            "error": "新しいパスキーを追加しようとしたときにエラーが発生しました。",
            "success": "新しいパスキーが追加されました。"
          },
          "delete": {
            "button": "パスキーを削除",
            "error": "このパスキーを削除しようとしたときにエラーが発生しました。",
            "success": "パスキーが削除されました。"
          },
          "edit": {
            "error": "パスキー名を保存しようとしたときにエラーが発生しました。",
            "name": "パスキー名",
            "success": "パスキー名が更新されました。",
            "title": "他のパスキーと区別するためにパスキーに名前を付けてください"
          },
          "info": "パスキーは、タッチ、顔認証、デバイスパスワード、PINを使用してあなたの身元を確認する、シンプルで安全なパスワードの代替手段です。",
          "none": "構成されているパスキーはありません。",
          "reallyDelete": "このパスキーを本当に削除しますか？",
          "registeredPasskeys": "登録済みのパスキー:",
          "title": "パスキー"
        },
        "reallyDeleteDevice": "認証デバイスを削除してもよろしいですか?",
        "secMFA": "多要素認証",
        "secPwdChange": "パスワードの変更",
        "title": "サインインとセキュリティ"
      },
      "setPW": {
        "acceptTC": "私たちの{terms}を確認し、私たちの{privacy}を読んでください。",
        "killSSO": "すべてのアクティブなセッションを無効にする",
        "msg": {
          "tokenExpired": "パスワードのリンクまたはコードの有効期限が切れています。リンクをクリックしてパスワードをリセットしてください：{link}."
        },
        "privacy": "プライバシーポリシー",
        "terms": "ご利用条件",
        "title": "パスワード登録"
      }
    },
    "validations": {
      "hasDigit": "数字(0-9)、",
      "hasLowercase": "小文字(a-z)、",
      "hasSpecial": "記号：{chars}",
      "hasUppercase": "アルファベット大文字(A-Z)、",
      "invalidCharacters": "無効な文字を含む",
      "maxLength": "最大{max}文字まで",
      "minLength": "{min}文字以上であること",
      "notSameAsEmail": "メールアドレスが類似しすぎています",
      "onlyValidCharactersAllowed": "文字、数字、スペースのみ使用できます。",
      "required": "必要な値",
      "sameAsPassword": "パスワードが一致しない",
      "tcAccepted": "ご利用規約をご確認ください。",
      "validEmail": "メールアドレスが無効です。",
      "validOTP": "認証コードを入力してください。"
    }
  }
}
